import React from "react"
import PropTypes from 'prop-types'
import { Button, Modal } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { withRouter } from "globals/utils"
import Loaded from 'components/loaded'
import { getRollover } from 'data/bmc/rollover/action'
import { getChangelog } from 'data/messages/action'
import logo from 'img/logo.png'
import api from 'api'
import '../style.css'

class LoadingPage extends React.Component{
  constructor(props) {
    super(props)
    this.state = { 
      loading: true,
      checkedPush: false,
      lastPush: null
    }
  }

  componentDidMount() {
    api.bmc.user.getUserLoginAction().then((ret)=>{
      if (!!ret) {
        this.setState({loading: false, lastPush: ret})
      } else  {
        this.continue(false)
      }
    }).catch(error=>{
      this.continue(false)
    })
  }

  componentDidUpdate(prevProps) {
    if (this.state.checkedPush) {
      if (!!this.props.changelog && this.props.changelog.length > 0) {       
        this.props.navigate("/whatsnew")
      } else if (!!this.props.events && this.props.events.length > 0) {
        this.props.navigate("/bmc/rollover")
      } else if (process.env.REACT_APP_TYPE==='NAV') {
        this.props.navigate("/home")
      } else {
        this.props.navigate("/bmc/thisyear")
      }
    }
  }
  continue = (reject) => {
    if (reject) {
      api.bmc.user.RejectAdvisorPush().then(()=>this.continue(false))
    } else {
      Promise.all([this.props.getChangelog(), this.props.getRollover()]).then(()=>{
        this.setState({checkedPush: true})})
    }
  } 
  handleAccept = () => {
    this.setState({loading: true})
    api.bmc.user.AcceptAdvisorPush().then(()=>this.continue(false))
  }
  render(){
    const { loading, checkedPush, lastPush } = this.state
    return(
      <div className="LoginScreen">
        <Loaded loading={loading} />
        <Modal size={'tiny'} closeOnEscape={false} closeOnDimmerClick={false} open={!loading && !!lastPush}>
          <Modal.Header>
            Your Advisor has sent you a plan update.
          </Modal.Header>
          <Modal.Content>
            Plan Sent: { lastPush }
          </Modal.Content>
          <Modal.Actions>
            <Button type="button" onClick={this.handleAccept} positive>Accept</Button>
            <Button type="button" onClick={ () => this.continue(true)} negative>Reject</Button>
          </Modal.Actions>
        </Modal>
      </div>
    )
  }
}
 
function mapStateToProps(state) {
  return {
    lastLogin: state.auth.lastLogin,
    isAuthenticated: !!state.auth.token, 
    status: state.auth.status,
    changelog: state.shared_data.messages.changelog,
    events: state.shared_data.bmc.rollover
  }
}

export default withRouter(connect(mapStateToProps, { getRollover, getChangelog })(LoadingPage))